function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#B0B1B1;}\r\n\t.st1{fill:#FFFFFF;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 302.2,
  cy: 139.8,
  r: 95.8
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M290,105.4c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6C285.8,95.8,290,100.1,290,105.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.2,105.4c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6C328.9,95.8,333.2,100.1,333.2,105.4z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M302,155.7c-12,0-23.1-6.4-29-16.8c-1.3-2.3-0.5-5.2,1.8-6.5s5.2-0.5,6.5,1.8c4.3,7.4,12.2,12,20.7,12s16.5-4.6,20.7-12 c1.3-2.3,4.2-3.1,6.5-1.8s3.1,4.3,1.8,6.5C325.1,149.3,314,155.7,302,155.7z"
})));

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.1602 -0.9871 0.9871 0.1602 74.8349 346.7579)",
  className: "st1",
  cx: 241.2,
  cy: 129.4,
  rx: 18,
  ry: 18
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 361.2,
  cy: 129.4,
  r: 18
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 110.8,
  cy: 298.7,
  r: 95.8
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M66.7,263.9c-1.8,0-3.4-1.1-4-2.9c-2.2-6.6,1.4-13.7,8-15.9s13.7,1.4,15.9,8c0.7,2.2-0.5,4.6-2.7,5.3 c-2.2,0.7-4.6-0.5-5.3-2.7c-0.7-2.2-3.1-3.4-5.3-2.7c-2.2,0.7-3.4,3.1-2.7,5.3c0.7,2.2-0.5,4.6-2.7,5.3 C67.6,263.8,67.2,263.9,66.7,263.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M102.6,252.1c-1.8,0-3.4-1.1-4-2.9c-2.2-6.6,1.4-13.7,8-15.9s13.7,1.4,15.9,8c0.7,2.2-0.5,4.6-2.7,5.3s-4.6-0.5-5.3-2.7 c-0.7-2.2-3.1-3.4-5.3-2.7c-2.2,0.7-3.4,3.1-2.7,5.3c0.7,2.2-0.5,4.6-2.7,5.3C103.5,252,103.1,252.1,102.6,252.1z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M62.6,286.9c7.1,21.7,30.5,33.5,52.2,26.4s33.5-30.5,26.4-52.2L62.6,286.9z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M166.6,94l-6.9-33.6c-0.8-4-3.1-7.4-6.5-9.6c-3.3-2.2-7.3-3-11.3-2.2c-4,0.8-7.3,3.1-9.5,6.3c-0.7-0.7-1.4-1.3-2.2-1.8 c-3.3-2.2-7.3-3-11.3-2.2c-4,0.8-7.3,3.1-9.5,6.3c-0.7-0.7-1.4-1.3-2.2-1.8c-3.3-2.2-7.3-3-11.3-2.2c-2.8,0.6-5.3,1.9-7.3,3.8 l-7.4-36.1c-0.8-4-3.1-7.4-6.5-9.6c-3.3-2.2-7.3-3-11.3-2.2C55.3,10.8,50,18.8,51.6,27l13.2,64.4L54.1,77c-2.4-3.3-5.9-5.4-9.9-6 c-4-0.6-8,0.4-11.2,2.8c-6.6,4.9-8.1,14.2-3.3,20.9c1.5,2.8,20.1,36.7,41.9,55.5l0.1,0.1h0.1c4.8,4.1,10.2,7.3,16.1,9.6 c10.6,4.2,22,5.2,33.1,2.9C152.5,156.3,173,125.4,166.6,94z M72.7,109.8l0.6,0.8l-0.2-0.9c0.2-0.1,0.4-0.3,0.6-0.4 c1.1-0.9,1.6-2.3,1.3-3.7l-2-9.9L58.8,25.6c-0.9-4.3,1.8-8.4,6.1-9.3c2-0.5,4.1-0.1,5.9,1.1c1.8,1.2,3,2.9,3.4,5l11.3,54.4 c0.4,1.9,2.4,3.2,4.3,2.8c1.9-0.4,3.2-2.4,2.8-4.3l-1.2-5.6c-0.9-4.3,1.8-8.4,6.1-9.3c2-0.5,4.1-0.1,5.9,1.1c1.8,1.2,3,2.9,3.4,5 l0.4,2.1l0.7,3.5c0.4,1.9,2.4,3.2,4.3,2.8c1.9-0.4,3.2-2.4,2.8-4.3l-0.7-3.4c-0.9-4.3,1.8-8.4,6.1-9.3c2-0.5,4.1-0.1,5.9,1.1 s3,2.9,3.4,5l0.7,3.4c0.4,1.9,2.4,3.2,4.3,2.8c1.9-0.4,3.2-2.4,2.8-4.3l-0.2-1.1c-0.9-4.3,1.8-8.4,6.1-9.3c2-0.5,4.1-0.1,5.9,1.1 c1.8,1.2,3,2.9,3.4,5l6.9,33.6c5.6,27.7-12.3,54.8-39.9,60.4c-9.8,2-19.8,1.1-29-2.5c-5.2-2.1-10-4.9-14.2-8.5 C54.8,125.9,36.2,91.3,36,90.9c-0.1-0.1-0.2-0.3-0.3-0.4c-2.6-3.5-1.9-8.4,1.6-11c0.9-0.7,2-1.2,3.1-1.4c0.9-0.2,1.8-0.2,2.7-0.1 c2.1,0.3,3.9,1.4,5.2,3.1l20.2,27.4c0.4,0.6,1,1,1.7,1.3C71,110.1,71.9,110.1,72.7,109.8z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M359.6,261.4c-8-2.2-16.4,2.5-18.6,10.5l-9.9,35.5c-1.9-2.1-4.3-3.5-7-4.3c-4.9-1.4-10-0.2-13.8,3c-1.9-3.4-5.1-5.9-9-7 c-4.9-1.4-10-0.2-13.8,3c-1.9-3.4-5.1-5.9-9-7c-8-2.2-16.4,2.5-18.6,10.5l-9.2,33c-8.6,31.1,9.6,63.3,40.6,72 c11,3.1,22.5,2.9,33.2-0.5c3.5-1.1,6.9-2.6,10.1-4.3c4.5-2.4,8.2-6.2,10.7-10.8l13.1-24.6c2.9-5.4,2.3-12-1.6-16.7l-5.4-6.7l18.7-67 C372.3,272,367.6,263.6,359.6,261.4z M276.6,302.1c4.2,1.2,6.7,5.6,5.5,9.7l-4.9,17.7c-1.1,4.2-5.5,6.7-9.7,5.5 c-4.2-1.1-6.7-5.5-5.5-9.7l4.9-17.7C268,303.4,272.4,300.9,276.6,302.1z M322.3,310.1c3.7,1.1,6,4.6,5.7,8.3 c-1.9-2.1-4.3-3.5-6.9-4.2c-2.7-0.8-5.4-0.8-8,0C314.7,310.9,318.6,309.1,322.3,310.1z M306,339.2l7,8.4c-0.4,0-0.8-0.1-1.2-0.2 C308.1,346.4,305.7,342.9,306,339.2z M304.9,315.8l-5.6,19.9c-1.1,4.2-5.5,6.7-9.7,5.5c-4.2-1.1-6.7-5.5-5.5-9.7l5.6-19.9 c1.1-4.2,5.5-6.7,9.7-5.5S306.1,311.6,304.9,315.8z M257.7,340.6l0.8-2.9c1.9,2.1,4.3,3.5,6.8,4.4c4.3,1.3,8.9,0.5,12.5-2 c1.9,4,5.3,7,9.7,8.2c4.3,1.3,8.9,0.5,12.5-2c1.9,4,5.3,7,9.7,8.2c2.8,0.8,5.8,0.7,8.5-0.1l2.9,3.5c0.5,0.5,0.6,1.2,0.4,1.9 c-0.2,0.7-0.7,1.2-1.4,1.4c-12,4-22.6,12.1-29.8,22.7c-1.1,1.6-0.7,3.9,1,5c1.6,1.1,3.9,0.6,5-1c6.3-9.3,15.6-16.4,26.2-19.9 c2.9-1,5.1-3.3,6-6.3c0.9-2.9,0.2-6.1-1.7-8.5l-15.9-19.4c-1.3-1.6-1.9-3.7-1.7-5.8s1.3-4,2.9-5.3c3.4-2.8,8.3-2.3,11.1,1.1 l28.2,34.5c2,2.5,2.3,5.9,0.8,8.7L339,391.6c-1.8,3.4-4.5,6.1-7.7,7.8c-2.8,1.6-5.8,2.8-8.9,3.8c-9.4,3-19.5,3.2-29.1,0.5 C266.1,396.1,250.1,367.8,257.7,340.6z M333.6,325.3l14.3-51.3c1.1-4.2,5.5-6.7,9.7-5.5c4.2,1.1,6.7,5.5,5.5,9.7l-17.3,62.1 L333.6,325.3z"
});

var SvgEnsemble = function SvgEnsemble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 413 435",
    style: {
      enableBackground: "new 0 0 413 435"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnsemble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ensemble.6c1e422b.svg";
export { ForwardRef as ReactComponent };